import { Card, CardBody, Col } from "reactstrap";
import { DefaultTouchSpinTitle } from "../../../../../constants";
import CommonTouchSpin from "./common/CommonTouchSpin";
import { DefaultTouchSpinData, TouchSpinSubTitle } from "../../../../../data/formsAndTable/forms/FormWidgets";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const DefaultTouchSpin = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={DefaultTouchSpinTitle} span={TouchSpinSubTitle} />
        <CardBody className="common-flex">
          {DefaultTouchSpinData.map((data, index) => (
            <CommonTouchSpin key={index} color={data} btnClass={`touchspin-${data}`} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default DefaultTouchSpin;
